import {
  Button, Checkbox, Text,
  Popover, PopoverTrigger, PopoverSurface,
  makeStyles, tokens,
} from '@fluentui/react-components'
import { ChevronDownRegular } from '@fluentui/react-icons'

export interface MultiSelectOption {
  value: string
  label: string
}

interface Props {
  label: string
  options: MultiSelectOption[]
  /** Vybrané hodnoty. Prázdné pole = nic vybráno. */
  value: string[]
  onChange: (value: string[]) => void
}

const useStyles = makeStyles({
  trigger: {
    minWidth: '150px',
    justifyContent: 'space-between',
  },
  triggerContent: {
    display: 'flex', alignItems: 'center', gap: '6px', flex: 1,
  },
  surface: {
    padding: '0',
    minWidth: '210px',
    boxShadow: tokens.shadow16,
  },
  actions: {
    display: 'flex',
    padding: '6px 8px',
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    gap: '2px',
  },
  list: {
    maxHeight: '290px',
    overflowY: 'auto',
    padding: '4px 0',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    padding: '1px 12px 1px 8px',
    cursor: 'pointer',
    userSelect: 'none',
    ':hover': { backgroundColor: tokens.colorNeutralBackground1Hover },
  },
})

export function MultiSelectFilter({ label: _label, options, value, onChange }: Props) {
  const styles = useStyles()

  const isChecked = (v: string) => value.includes(v)

  const btnLabel = value.length === options.length
    ? 'vybráno vše'
    : value.length === 0
    ? 'vybráno 0'
    : `vybráno ${value.length}`

  const toggle = (v: string) => {
    const next = value.includes(v)
      ? value.filter(id => id !== v)
      : [...value, v]
    onChange(next)
  }

  return (
    <Popover positioning="below-start">
      <PopoverTrigger disableButtonEnhancement>
        <Button className={styles.trigger} icon={<ChevronDownRegular />} iconPosition="after">
          {btnLabel}
        </Button>
      </PopoverTrigger>

      <PopoverSurface className={styles.surface}>
        {/* Vybrat / Zrušit vše */}
        <div className={styles.actions}>
          <Button appearance="transparent" size="small" onClick={() => onChange(options.map(o => o.value))}>
            Vybrat vše
          </Button>
          <Button
            appearance="transparent"
            size="small"
            onClick={() => onChange([])}
            style={{ color: tokens.colorNeutralForeground3 }}
            disabled={value.length === 0}
          >
            Zrušit výběr
          </Button>
        </div>

        {/* Seznam položek */}
        <div className={styles.list}>
          {options.map(opt => (
            <div key={opt.value} className={styles.row} onClick={() => toggle(opt.value)}>
              {/* pointerEvents: none → klik bubbluje na row div, ne na checkbox */}
              <span style={{ pointerEvents: 'none', display: 'flex', alignItems: 'center' }}>
                <Checkbox checked={isChecked(opt.value)} onChange={() => {}} />
              </span>
              <Text size={300}>{opt.label}</Text>
            </div>
          ))}
        </div>
      </PopoverSurface>
    </Popover>
  )
}
